module.exports = __webpack_public_path__ + "static/img/bulletin-case.ea19597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bulletin-boards/bulletin-case.jpg
// module id = 707
// module chunks = 0